import React from 'react';
import { Carousel } from "antd";
import ReactPlayer from "react-player";

const InfluencerContent = ({ contents }) => {
  function contentToImageOrVideo(content) {
    if (content["type"] === "VIDEO") {
      // make it round
      return (
        <ReactPlayer
          url={[
            {
              src: content["contentUrl"] + "?tr=h-700,f-webm",
              type: "video/webm",
            },
            { src: content["contentUrl"], type: "video/mp4" },
          ]}
          controls
          muted
          width="100%"
          height="100%"
          lazyload
          playsinline
          loop
          style={{ borderRadius: "5px 5px 0px 0px" }}
        />
      );
    } else {
      return (
        <img
          alt={content["contentUrl"]}
          src={content["contentUrl"]}
          style={{ width: "100%", borderRadius: "5px 5px 0px 0px" }}
        />
      );
    }
  }

  return (
    <div>
      <Carousel>
        {contents.map((content) => {
          return <div>{contentToImageOrVideo(content)}</div>;
        })}
      </Carousel>
    </div>
  );
};

export default InfluencerContent;